import React, { useState } from 'react';
import { MapPin, Phone, Mail, Send, Clock, User, MessageCircle, Info } from 'lucide-react';
import './Contact.css';
import API_BASE_URL from '../../../config/api';

const Contact = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.nome,
          email: formData.email,
          subject: formData.assunto,
          message: formData.mensagem
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({ type: 'success', text: 'Mensagem enviada com sucesso! Entraremos em contacto em breve.' });
        setFormData({
          nome: '',
          email: '',
          assunto: '',
          mensagem: ''
        });
      } else {
        let errorMsg = 'Erro ao enviar mensagem. Tente novamente.';
        if (data.errors) {
          const errorList = Object.values(data.errors).flat();
          errorMsg = errorList.join(' ');
        } else if (data.message) {
          errorMsg = data.message;
        }
        setMessage({ type: 'error', text: errorMsg });
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage({ type: 'error', text: 'Erro ao enviar mensagem. Verifique sua conexão e tente novamente.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contactos" className="contact section-padding">
      <div className="container">
        <div className="contact-header animate-in">
          <span className="contact-subtitle">Fale Connosco</span>
          <h2 className="contact-title">Entre em Contacto</h2>
          <div className="contact-header-line"></div>
          <p className="contact-description">
            Tem alguma questão ou gostaria de saber mais sobre o clube? Estamos aqui para ajudar e ouvir a nossa comunidade.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-info-wrapper animate-in" style={{ '--delay': '0.1s' }}>
            <div className="contact-info-item glass-card">
              <div className="icon-glow-circle">
                <Phone className="contact-icon" />
              </div>
              <div className="info-content">
                <h4>Telefone</h4>
                <p>+351 252 682 109</p>
              </div>
            </div>

            <div className="contact-info-item glass-card">
              <div className="icon-glow-circle">
                <Mail className="contact-icon" />
              </div>
              <div className="info-content">
                <h4>Email</h4>
                <p>geral@cdpovoa.pt</p>
              </div>
            </div>

            <div className="contact-info-item glass-card">
              <div className="icon-glow-circle">
                <MapPin className="contact-icon" />
              </div>
              <div className="info-content">
                <h4>Sede Social</h4>
                <p>Largo Dr. José Pontes, 4490-556 Póvoa de Varzim</p>
              </div>
            </div>

            <div className="hours-card">
              <h4><Clock size={20} /> Horário de Atendimento</h4>
              <div className="hour-row">
                <span>Segunda a Sexta:</span>
                <span className="time-highlight">14h30 - 19h00</span>
              </div>
              <div className="hour-row">
                <span>Sábados:</span>
                <span className="time-highlight">09h30 - 12h00</span>
              </div>
              <div className="hour-row">
                <span>Domingos:</span>
                <span className="closed-tag">Encerrado</span>
              </div>
            </div>
          </div>

          <div className="contact-form-wrapper glass-card animate-in" style={{ '--delay': '0.2s' }}>
            <div className="form-header">
              <h3><MessageCircle size={24} /> Envie-nos uma Mensagem</h3>
              <p>Preencha o formulário e responderemos o mais breve possível.</p>
            </div>

            {message.text && (
              <div className={`contact-alert alert-${message.type}`}>
                <Info size={18} /> {message.text}
              </div>
            )}

            <form onSubmit={handleSubmit} className="premium-form">
              <div className="form-row">
                <div className="form-group">
                  <label><User size={14} /> Nome Completo *</label>
                  <input
                    type="text"
                    name="nome"
                    placeholder="O seu nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label><Mail size={14} /> Email *</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="seu.email@exemplo.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Assunto *</label>
                <div className="select-wrapper">
                  <select
                    name="assunto"
                    value={formData.assunto}
                    onChange={handleChange}
                    required
                    disabled={loading}
                  >
                    <option value="">Selecione um assunto</option>
                    <option value="apoio_social">Bolsa de Apoio Social</option>
                    <option value="inscricoes">Inscrições</option>
                    <option value="socio">Sócio</option>
                    <option value="outros">Outros</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Mensagem *</label>
                <textarea
                  name="mensagem"
                  rows="4"
                  placeholder="A sua mensagem (mínimo 10 caracteres)..."
                  value={formData.mensagem}
                  onChange={handleChange}
                  required
                  minLength={10}
                  disabled={loading}
                ></textarea>
              </div>

              <button type="submit" className="premium-submit-btn" disabled={loading}>
                {loading ? (
                  <span className="loading-spinner"></span>
                ) : (
                  <>
                    <span>Enviar Mensagem</span>
                    <Send className="btn-icon" />
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;